import { render } from "./InputFileManager.vue?vue&type=template&id=0c65d9e5&scoped=true"
import script from "./InputFileManager.vue?vue&type=script&lang=js"
export * from "./InputFileManager.vue?vue&type=script&lang=js"

import "./InputFileManager.vue?vue&type=style&index=0&id=0c65d9e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c65d9e5"]])

export default __exports__